<template>
	<div>
		<div class="chart_example" :id="id">
		</div>
	</div>
</template>

<script>
  import echarts from 'echarts'
  export default {
    data() {
      return {}
    },
    props: ['id', 'catetoryData'],
    mounted() {
      let this_ = this;
      let id = this.id;
      let catetoryData = this.catetoryData;
      let myChart = echarts.init(document.getElementById(id));
      let name = [{
          "name": "参数1",
          "value": 1500
      }]
      let option = {
        backgroundColor: '#FFFFFF',
        title: [{
          text: '平均处理时长 | 就诊流程',
          left: '1%',
          top: '2%',
          textStyle: {
            fontSize: '16px',
            fontFamily: 'PingFang SC',
            fontWeight: 400,
            color: 'rgba(51,51,51,1)'
          }
        }],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#57617B'
            }
          },
          formatter: function (prams) {
            if (prams[0].data === 0) {
              return "0天"
            } else {
              return "" + prams[0].data + "天"
            }
          }
        },
        legend: {
          orient: 'horizontal',
          right: "50%",
          bottom: '1%',
          textStyle: {
            color: '#ffd285',
          },
          // formatter: '1000家',
          icon: 'circle',
          //  icon: 'roundRect',
          itemWidth: 10,
          itemHeight: 10,
          data: name,
        },
        grid: {
          left: '5%',
          right: '10%',
          bottom: '5%',
          top: '10%',
          textStyle: {
            color: "#EDEEF0"
          },
          containLabel: true,
          z: 22
        },
        xAxis: [{
          type: 'category',
          gridIndex: 0,

          // data: ['原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油', '原油加工及石油'],
          data: catetoryData.yAxisData,
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              //  color: '#EDEEF0',
              width: '26px'
            }
          },
          axisLabel: {
            interval: 0,
            formatter: function (value) {
              return (value.length > 8 ? (value.slice(0, 8) + "...") : value)
            },
            rotate: 45,
            color: '#7cb4d8',
            margin: 10,
            textStyle: {
              color: '#A4A4A4',
              fontSize: '14px',
            }
          }
        }],
        yAxis: [{
          type: 'value',
          //   name: "单位:户",
          nameTextStyle: {
            color: '#EDEEF0'
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#EDEEF0',
              width: '26px'
            }
          },
          gridIndex: 0,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#EDEEF0'
            }
          },
          axisLabel: {
            formatter: '{value}',
            margin: 10,
            textStyle: {
              color: '#A4A4A4',
              fontSize: '14px',
            }
          }
        },
        {
          type: 'value',
          gridIndex: 0,
          min: 0,
          max: 100,
          splitNumber: 12,
          splitLine: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          }
        }],
        series: [{
          name: '',
          type: 'bar',
          stack: '预警',
          xAxisIndex: 0,
          yAxisIndex: 0,
          itemStyle: {
            normal: {
              barBorderRadius: [0, 0, 0, 0],
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1, [{
                  offset: 0,
                  color: '#005dff'
                },
                {
                  offset: 1,
                  color: '#005dff'
                }]
              )
            }
          },
          barWidth: 10,
          //data: [20, 69, 56, 34, 45, 56, 67, 67, 87, 45, 87, 99, 69, 56, 34, 45, 56, 67, 67, 87, 45, 87, 99, 69, 56, 34, 45, 87],
          data: catetoryData.seriesData,
          zlevel: 11
        }

        ]
      };

      myChart.setOption(option);
      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener('resize', function () {
          myChart.resize()
      });
    }
  }
</script>
<style scoped>
	h2 {
		text-align: center;
		padding: 30px;
		font-size: 18px;
	}

	.chart_example {
		height: 546px;
		padding: 20px;
		background: #fff;
		/* border: 1px solid red; */
		margin: 0 auto;
	}
</style>